import { format } from 'date-fns'

export const formatDate = (date: any) => (date ? format(new Date(date), 'dd.MM.yyyy, HH:mm') : '')

// Separate from formatDate, which many other screens use and which throws on an unreadable date.
export const formatAccountDate = (date?: string | number | Date | null) => {
  if (!date) return '—'

  const at = new Date(date)

  return Number.isNaN(at.getTime()) ? '—' : format(at, 'd MMM yy, HH:mm')
}
